import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";

import { Panel, PanelBody, PanelHeader } from "../../components/Panel";
import { Text } from "../../components/Text";
import Loader from "../../components/Loader";
import { BlocksByDayInsight, TagTime } from "@aika/types";
import { sum } from "lodash";
import { Flex } from "components/Flex";
import { DonutGraph } from "./DonutGraph";
import { DateRange, dateRangeValue } from "components/DateRangeControl";
import { format } from "date-fns";

export function PrioritiesWidget({ range }: { range: DateRange }) {
  const [tags, setTags] = useState<TagTime[]>([]);
  const [data, setData] = useState<BlocksByDayInsight>(null!);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const dates = dateRangeValue(range);
    const url = `/api/insights/priorities?start=${format(
      dates[0],
      "yyyy-MM-dd"
    )}&end=${format(dates[1], "yyyy-MM-dd")}`;
    axios.get<TagTime[]>("/api/reports/time-by-tag").then(({ data }) => {
      axios.get<BlocksByDayInsight>(url).then((res) => {
        setTags(data);
        setData(res.data);
        setLoading(false);
      });
    });
  }, [range]);

  const pris = useMemo(() => {
    if (tags == null || data == null) {
      return [];
    }
    return Object.entries(data.tags)
      .map(([id, d]) => {
        const label = tags.find((x) => x.id === id)?.name;
        return {
          label: label ?? "",
          value: sum(d.map((x) => x.totalTime)),
        };
      })
      .sort((a, b) => b.value - a.value)
      .slice(0, 8);
  }, [data, tags]);

  return (
    <>
      <Panel p={0}>
        <PanelHeader>
          <Text fontSize={[3, 4]} fontWeight={600}>
            Your Priorities
          </Text>
        </PanelHeader>
        <PanelBody>
          <Flex
            alignItems="center"
            justifyContent="center"
            height="100%"
            flex="1"
          >
            {loading && <Loader overlay />}
            <DonutGraph values={pris} />
          </Flex>
        </PanelBody>
      </Panel>
    </>
  );
}
